import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';

import {useSettings} from './useSettings';

const defaultDetailsModalSettings = {
    isOpen: false,
    isLoading: false,
    isSecondaryActionDisabled: undef
};

function useDetailsModalSettings(props) {
    const {
        detailsModalSettings: propsDetailsModalSettings
    } = props;

    const {
        initialSettings: initialDetailsModalSettings,
        settings: detailsModalSettings,
        changeSettings: changeDetailsModalSettings
    } = useSettings(defaultDetailsModalSettings, propsDetailsModalSettings);

    const result = {
        initialDetailsModalSettings,
        detailsModalSettings,
        changeDetailsModalSettings
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalSettings};
